export default "__VITE_ASSET__DZYdaK9f__"